export default __webpack_public_path__ + "static/media/Rectangle 223@2x.47672c38.png";